import { Component } from '@angular/core';
import { StyleAppHelper } from './providers/style-app-helper';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
})
export class AppComponent {
    constructor(private styleAppHelper: StyleAppHelper) {
        const styleSheet = document.createElement('link');
        styleSheet.addEventListener('load', () => {
            this.styleAppHelper.loadStyles();
        });
        styleSheet.rel = 'stylesheet';
        styleSheet.href = 'remote-style.css';
        document.getElementsByTagName('head')[0].appendChild(styleSheet);
    }
}
